import { render, staticRenderFns } from "./NotificationsItem.vue?vue&type=template&id=50cf0145&scoped=true"
import script from "./NotificationsItem.vue?vue&type=script&lang=js"
export * from "./NotificationsItem.vue?vue&type=script&lang=js"
import style0 from "./NotificationsItem.vue?vue&type=style&index=0&id=50cf0145&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cf0145",
  null
  
)

export default component.exports